import React, { useState, useEffect, useRef, Fragment } from "react"
import { useTranslation } from "react-i18next"

import OrdersFilterSidebar from "./OrdersFilterSidebar"
import { Input } from "components"
import classes from "./index.module.scss"
import OrderFilterButton from "./OrderFilterButton"

const OrdersFilter = props => {
  const {
    filters,
    setFilters,
    setOrderCode
  } = props

  const [t] = useTranslation()

  const [input, setInput] = useState("")
  const [openFilterSidebar, setOpenFilterSidebar] = useState(false)
  const [initialUsersList, setInitialUsersList] = useState(null)
  const [initialAccessList, setInitialAccessList] = useState(null)

  const timeout = useRef(null)
  const unmount = useRef(false)

  const handleChange = e => {
    const value = e.target.value

    setInput(value)

    clearTimeout(timeout.current)

    timeout.current =
      setTimeout(() => setOrderCode(value), 600)
  }


  useEffect(() => {
    unmount.current = false

    return () => {
      unmount.current = true
    }
  }, [])

  useEffect(() => {
    return () => clearTimeout(timeout.current)
  }, [])

  return (
    <Fragment>
      <div className={classes["row"]}>
        <Input
          value={input}
          className={classes["input"]}
          placeholder={t("جست_و_جو_سفارشات_با_کد")}
          onChange={handleChange}
        />

        <OrderFilterButton
          filters={filters}
          setOpenFilterSidebar={setOpenFilterSidebar}
        />
      </div>

      <OrdersFilterSidebar
        filters={filters}
        setFilters={setFilters}
        openFilterSidebar={openFilterSidebar}
        setOpenFilterSidebar={setOpenFilterSidebar}
        initialUsersList={initialUsersList}
        setInitialUsersList={setInitialUsersList}
        initialAccessList={initialAccessList}
        setInitialAccessList={setInitialAccessList}
      />
    </Fragment>
  )
}

export default OrdersFilter